module.exports = __webpack_public_path__ + "static/media/alert-error.ab741b4b.svg";